// Token de sesión. Va en localStorage (no en sessionStorage) para que la app
// instalada conserve la sesión al cerrarla y pueda abrirse sin internet:
// iniciar sesión siempre requiere conexión, pero una sesión ya iniciada sigue
// funcionando mientras el token esté vigente.
const TOKEN_KEY = "token";

// Última respuesta de /auth/login/verify-token: permite seguir trabajando si se cae internet
export const SESION_VERIFICADA_KEY = "sesionVerificada";

export const obtenerToken = () => localStorage.getItem(TOKEN_KEY);

export const guardarToken = (token) => localStorage.setItem(TOKEN_KEY, token);

export const leerSesionVerificada = () => {
    try {
        return JSON.parse(localStorage.getItem(SESION_VERIFICADA_KEY));
    } catch {
        return null;
    }
};

export const guardarSesionVerificada = (datos) =>
    localStorage.setItem(SESION_VERIFICADA_KEY, JSON.stringify(datos));

// Borra todo lo de la sesión (incluye el token que antes vivía en sessionStorage)
export const limpiarSesion = () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(SESION_VERIFICADA_KEY);
    localStorage.removeItem('iduser');
    sessionStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem('tokenNotas');
};
